import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { CSVLink } from 'react-csv';
import ReactDataGrid from 'react-data-grid';
import { Toolbar } from 'react-data-grid-addons';
import {
    Button, Card, CardText, CardTitle, Cell, Checkbox, DialogContainer,
    Divider, Grid,
    List, ListItem, MenuButton,
    SelectField
} from 'react-md';
import MultiSelectReact from 'react-multi-select-ext';
import {
    NotificationContainer,
    NotificationManager
} from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import ApiRequestService from '../component/ApiRequestService';
import CourseDropDown from '../component/CourseDropDown';
import LoadingSpinner from '../component/LoadingSpinner';
import SectionDropDown from '../component/SectionDropDown';
import SecureShow from '../component/SecureShow';
//CSS Imports
import '../css/Dashboard.css';
import '../css/gradeBook.css';
import { AppSetting, AppProperties } from '../common/function';





//Common Fuctions
const addQuizesIfUnique = (quizArray,newQuizArray) => {
    if(quizArray && newQuizArray){
        const quizArrayTemp = [...quizArray];
        newQuizArray.forEach(quizItem=>{
            const index = quizArrayTemp.findIndex(x => x.quiz_id === quizItem.quiz_id)
            if (index === -1) {
                quizArrayTemp.push(quizItem);
            }else {
                console.log("Duplicate");
                 
            }
        });
        return quizArrayTemp.sort(function(a, b){return a.quiz_id - b.quiz_id});
    }
    return [];
} 
let QuizScoreColumn =   function(props)
{
    return <MenuButton
    id={"menu-button-"+props.index}
    flat
    primary
    fullWidth
    menuItems={[<ListItem key="menuStatistics" 
                onClick={() => (
                    props.onClick(props.quiz)
                )} 
    primaryText="Statistics">
    </ListItem>]}
    
  >
    {props.quiz.quiz_name}
  </MenuButton>
}

let QuizStatsReport = function(props)
{
    const style = { maxWidth: 600 };
 
   let {quizName,CountAttended,CountCompleted,CountInProgress,Max,Mean,Median,Min,StandardDeviation}   =   props.stats;
    let title   =   quizName+" - Statistics";
    return <Card  style={style} className='md-block-centered assignment-stats-card' id={props.id}>
                <CardTitle title={title}  className="assignment-stats-card-title" />
                <CardText>
                <List ordered>
                    <Divider />
                    <ListItem primaryText="Total Students"  >
                        {CountAttended}
                    </ListItem>
                    <ListItem primaryText="Students who have Started " >
                        {CountInProgress}
                    </ListItem>
                    <ListItem primaryText="Students who have Completed ">
                       {CountCompleted}
                    </ListItem>
                    <Divider />
                    <ListItem primaryText="Max Score"  >
                        {Max}
                    </ListItem>
                    <ListItem primaryText="Min Score" >
                        {Min}
                    </ListItem>
                    <Divider  />
                    <ListItem primaryText="Mean">
                       {Mean}
                    </ListItem>
                    <ListItem primaryText="Median" >
                        {Median}
                    </ListItem>
                    <ListItem primaryText="StandardDeviation">
                       {StandardDeviation}
                    </ListItem>

                </List>
                </CardText>
            </Card>
}

//Retrives Section IDs from SectionIDs Object Array
const getSectionIDsArray = (sectionIDsObjectArray) =>{
    let sectionnIDsArray = [];

    if(sectionIDsObjectArray !== undefined && sectionIDsObjectArray !== null){
        sectionnIDsArray    =   sectionIDsObjectArray.map((secIDObject)=>{
            return secIDObject.index;
        });
    }

    return sectionnIDsArray;
}

const getSectionIDsMap = (sectionIDsObjectArray) =>{
    let sectionIDsMap = {};

    if(sectionIDsObjectArray !== undefined && sectionIDsObjectArray !== null){
        for(const section of sectionIDsObjectArray){
            sectionIDsMap[section.index] = section;
        }
    }

    return sectionIDsMap;
}

//Retreives quiz stats
const  getQuizStats = (quizDetails) => {
    const payload = {"courseID":quizDetails.course_id,"sectionIDs":getSectionIDsArray(quizDetails.sectionIDs),"quizID":quizDetails.quiz_id,"quizType":quizDetails.quiz_type};
    const statsPromise =  new Promise(function(resolve, statsPromisereject){
        
        ApiRequestService({
            method: 'post',
            url:'getAssignStats',
            data: payload
            }).then(res => {
                
                if(res.data !== undefined && 
                  res.data !== null &&
                  res.data.status !== undefined && 
                  res.data.status !== null)
                {
                    if(res.data.status !== 0)
                        {
                            statsPromisereject(res.data.message);
                        }else if(res.data.data !== undefined && res.data.data !== null){
                            resolve(res.data.data)
                        }else
                        {
                            statsPromisereject("Server sent Nothing");
                            NotificationManager.error("There was an Error when retriving Assignment Stats, please contact support team","Error - Empty Response",5000);
                        }
                   
                }else{
                    statsPromisereject("Server sent Nothing");
                    NotificationManager.error("There was an Error when  retriving Assignment Stats, please contact support team","Error",5000);
                }
            }).catch(error =>{
                statsPromisereject(error);
                NotificationManager.error(error,"Error",5000);
            });
      });


      return statsPromise;
}

class TotalScoreFormatter extends React.PureComponent {

    static propTypes = {

        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.bool])

    };




    render() {
        
        
        let {score,highlight,editedBy} = this.props.value;
        
        
        if(highlight){
            return <div className={highlight?"scoreChangedHighlight":null} title={"Score Edited By : "+editedBy}>{score}</div>
            
        }
        if (score !== undefined && score !== null && !isNaN(score))
            return <div className={highlight?"scoreChangedHighlight":null} title={score}>{score}</div>;
        else
        {
            return null;
        }
           
    }

}
//Used to Edit Scores 
class TotalScoreEditor extends ReactDataGrid.editors.EditorBase {

    render() {
  
      return (<input ref={(node) => this.input = node} type="text" onBlur={this.props.onBlur} className="form-control" defaultValue={this.props.value.score} />);
  
    }
  
}



//Custom Toolbar with Quiz Filter
export class GradeBookToolbar extends Toolbar {
   
    
    
    renderQuizFilter(){
        
        const selectedOptionsStyles = {
            color: '#FFFFFF',
            backgroundColor: '#bb0000'
        };
        const optionsListStyles = {
            backgroundColor: '#FFFFFF',
            color: '#bb0000'
        };
        
        return <MultiSelectReact
                    options={this.props.quizCheckBox}
                    optionClicked={this.props.onQuizFilterToggle}
                    selectedBadgeClicked={this.props.onQuizFilterToggle}
                    selectedOptionsStyles={selectedOptionsStyles}
                    optionsListStyles={optionsListStyles}
                    enableSelectAllNone={true}
                />

    }

    render() {
      return (
        <div className="react-grid-Toolbar">
          <div className="tools">

          {this.renderToggleFilterButton()}
          {this.renderQuizFilter()}
          </div>
        </div>);
    }
  }


export default class GradebookPage extends PureComponent {
    AppSetting = AppSetting();
    appProperties = AppProperties();

    constructor(props) {
        super(props);
        this.state = {
          selectedCourseID: 0,
          selectedSectionIDs:[],
          columnsForQuiz:[],
          rows:[],//Gradebook Data, preprocessed for UI
          showDialog:false,
          gradeBookHeight:-1,
          fetchingGradebook:false,
          fetchingQuizStats:false,
          buildingOverViewCSV:false,
          quizCheckBox:[],
          overAllCSVData:[],
          showStudentStatsDrawer:true,
          archiveMode:false,
          loadingArchivedList:false,
          archivedSemester:[],
          loadingCourse:false,
          courses:undefined,
          availabelTotScore:[],
          includeInstructorGrade:false,
          allRows:[], //this will hold all the rows, including the instructor and admin
        };

        this.questionCount  =   {};
        this.quizList = [];
        this.gradebookArray = [];
        this.scoreCache = {};   //Cache Previous API Request to avoid hitting database again

        this.downloadCSV    =   this.downloadCSV.bind(this);
        this.onQuizFilterToggle =   this.onQuizFilterToggle.bind(this);
        
      }

    handleToggleInstructorGrade = () => {
        this.setState(prevState => {
            const newIncludeInstructorGrade = !prevState.includeInstructorGrade;
            let newRows = [];
            if (!newIncludeInstructorGrade) {
                // Filter out instructor and admin(role 1 and 2)
                newRows = this.state.allRows.filter(row => row.RoleID !== 1 && row.RoleID !== 2);
            } else {
                // Include all rows
                newRows = this.state.allRows;
            }
            return {
                includeInstructorGrade: newIncludeInstructorGrade,
                rows: newRows
            };
        });
    };

      /*

      Code to Enable Archive Mode
      */
    
    enableArchiveMode = (value) =>{
        this.getArchivedSemesters();
            this.setState({fetchingGradebook:false,archiveMode:value,loadingCourse:true,selectedCourseID:0,selectedSectionIDs:[],columnsForQuiz:[],selectedSemesterID:-1});
        if(!value)
            this.setState({loadingCourse:false});
    }


    getArchivedSemesters = async() =>{
        this.setState({loadingArchivedList:true});
        try{
            let getArchivedSemestersResponse = await ApiRequestService({
                method: 'post',
                url:'getArchivedSemesters',
                data: ''
            })
            if(getArchivedSemestersResponse.data !== undefined && getArchivedSemestersResponse.data !== null){
                if(getArchivedSemestersResponse.data.status === 0 && getArchivedSemestersResponse.data.data !== undefined && getArchivedSemestersResponse.data.data !== null){
                    this.setState({'archivedSemester':getArchivedSemestersResponse.data.data });
                }else if (getArchivedSemestersResponse.data.message !== undefined &&  getArchivedSemestersResponse.data.message !== null ) {
                    NotificationManager.error(getArchivedSemestersResponse.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
            }
        }catch(err){
           
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({loadingArchivedList:false});
        }
    }


    onSemesterChange = (value, index, event, details) => {
       
        this.setState({selectedSemesterID:value,selectedCourseID:0,selectedSectionIDs:[],columnsForQuiz:[]});
        this.getArchivedCoursesAndSections(value);
    }

    getArchivedCoursesAndSections = async(selectedSemesterID) => {
        this.setState({loadingCourse:true,showSection:false,showDashBoard:false});
        try{
            let getArchivedCourses = await ApiRequestService({
                method: 'post',
                url:'getArchivedCourses',
                data: selectedSemesterID
            })
            if(getArchivedCourses.data !== undefined && getArchivedCourses.data !== null){
                if(getArchivedCourses.data.status === 0 && getArchivedCourses.data.data !== undefined && getArchivedCourses.data.data !== null){
                    if(getArchivedCourses.data.data.courses !== undefined && getArchivedCourses.data.data.courses !== null){
                        this.setState({courses:getArchivedCourses.data.data.courses});
                    }else{
                        NotificationManager.error("No Courses Found for Semester","Error",5000);
                    }
                    if(getArchivedCourses.data.data.sectionMap !== undefined && getArchivedCourses.data.data.sectionMap !== null){
                        this.setState({sectionMap:getArchivedCourses.data.data.sectionMap});
                    }else{
                        NotificationManager.error("No Sections Found for Semester","Error",5000);
                    }

                }else if (getArchivedCourses.data.message !== undefined &&  getArchivedCourses.data.message !== null ) {
                    NotificationManager.error(getArchivedCourses.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
            }
        }catch(err){
           
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({loadingCourse:false});
        }
    }

    //End Archive Mode Changes


    calculateGradebookHeight = () => {
            let delta = 200;
            let dropDownCell = document.getElementById('courseDropboxCell');
            if (dropDownCell !== undefined &&  dropDownCell !== null){
                // 32 =   8 + 8 + 8 + 8 (ie top and bottom marigin of the 2 cells)
                //60 Space for Tool Bar
                //5 for good luck :)
                delta = dropDownCell.offsetHeight + 32 + 60 + 5;
            }
            return  window.innerHeight - delta;
        
    }

    setgridHeight = () => {
            this.setState({gradeBookHeight:this.calculateGradebookHeight()});
    }
    monitorWindowSize = () => {        
        window.addEventListener("resize",this.setgridHeight);
    } 
    
    componentWillMount() {
        if(this.props.archiveMode){
            this.enableArchiveMode(true);
        }
        this.monitorWindowSize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize",this.setgridHeight);
    }

    //Build Quiz Filter
    

    //On    Course Selected
    onCourseChange = (argSelectedCourseID) => {
        this.setState({
          selectedCourseID: argSelectedCourseID,
          selectedSectionIDs:[],
          columnsForQuiz:[]
        });
    };

    //On Section Selected
    onSectionChange = (argSelectedSectionIDs) => {
        console.log("argSelectedSectionIDs",argSelectedSectionIDs);
        let selectedSectionIDs = []
        
        if (argSelectedSectionIDs && argSelectedSectionIDs.length) {
            argSelectedSectionIDs.forEach(argSelectedSectionID => {
                if (argSelectedSectionID.index && argSelectedSectionID.value) {
                    selectedSectionIDs.push(argSelectedSectionID)
                }
            })
        }
        
        this.setState({
            selectedSectionIDs: selectedSectionIDs,
        });
        
        this.getScores(selectedSectionIDs,this.state.selectedCourseID);
        
    };


     // Instead of hitting server, we cache the results
     getScoreCache = async (selectedSectionID,selectedCourseID) => {
        

        
        let key = selectedCourseID+'-'+selectedSectionID;
        if (key in this.scoreCache) {
            
            return this.scoreCache[key];
        }
        else {
            
            let result = await this.getScore(selectedSectionID,selectedCourseID);
            let quizList = await this.getAllQuizes(selectedSectionID,selectedCourseID);
            const quizResultObject = {...result,...quizList};
            this.scoreCache[key] = quizResultObject;
            return {...quizResultObject};
        }
        
     }


    //GetGradeBook from Server
    //getScores :- Will Get Scores for Multiple Sections and Build the GradeBook Array, 
    //I am not changing the Server URL to handles multiple sections at once, since users tended to add sections from drop down in increments to all together and remove a few at a time.

     getScores = (selectedSectionIDs,selectedCourseID) => {
        this.setState({fetchingGradebook:true});

         if(selectedSectionIDs !== undefined && selectedSectionIDs !== null && selectedSectionIDs.length > 0){
            let promises = [];
             for (const selectedSectionID of selectedSectionIDs){
                if(selectedSectionID.value )
                {
                 let result =  this.getScoreCache(selectedSectionID.index,selectedCourseID);
                 promises.push(result);
                }
             }
                
            

            Promise.all(promises).then(results =>{
                
                
                let allGrades  = [];
                let allQuizes = [];
                let questionsCount  = {};
                for(const result of results){
                    if(result!==undefined && result!== null){
                        if(result.GradeBooks !== undefined && result.GradeBooks !== null)
                        {                           
                            allGrades = allGrades.concat(result.GradeBooks);
                        }
                        if(result.quizes_list !== undefined && result.quizes_list !== null){
                            allQuizes= addQuizesIfUnique(allQuizes,result.quizes_list);
                        }
                        if(result.QuestionCount !== undefined && result.QuestionCount !== null)
                        {
                            questionsCount = Object.assign(questionsCount,result.QuestionCount);
                        }
                        
                    }
                    
                    
                }
                console.log("allQuizes, allGrades",allQuizes, allGrades);
                
                if( !allQuizes || allQuizes.length === 0 || !allGrades || allGrades.length === 0){
                    //No Gradebook data -> https://gitlab.com/ontoborn/es2.0-client/-/issues/162
                    NotificationManager.error("No Gradebook Data","Error",5000);
                    this.setState({fetchingGradebook:false});
                    return
                }
                this.gradebookArray = allGrades;
                this.allQuizes = allQuizes;
                this.fillQuizFilterCheckBox(allQuizes);
                this.buildGradeBookColumns(allQuizes,!this.state.archiveMode);
                this.questionCount  =   questionsCount;
                this.buildUIData(allGrades);   
            }).catch(err =>{
                console.error("Error retriving Gradebook",err);
                NotificationManager.error("There was an Error when loading Gradebook, please contact support team with the Error =>"+err,"Error",5000);
                this.setState({fetchingGradebook:false});
            }).finally(() => {
                this.setState({fetchingGradebook:false});
            });
              
         }
        
        
     }

    
     getScore = async (selectedSectionID,selectedCourseID) => {
        const payload = {
        courseID:selectedCourseID,
        sectionID:selectedSectionID,
        archiveMode:this.state.archiveMode,
        semesterID:this.state.selectedSemesterID
        };
        
        
        let apiURL  =  "/gradebook"
        
        try{
            
            let gradeBookResponse = await ApiRequestService({
            method: 'post',
            url:apiURL,
            data: payload
            })
            if(gradeBookResponse.data !== undefined && gradeBookResponse.data !== null 
                &&
                gradeBookResponse.data.data !== undefined && gradeBookResponse.data.data!== null
                && gradeBookResponse.data.data.GradeBooks!== null){
                    return gradeBookResponse.data.data;
                    
                
            }
            
        }catch(err){
           
            return err;
        }finally{
            
        }
    }

    getAllQuizes = async(selectedSectionID,selectedCourseID) => {
        
        const payload = {
            course_id:selectedCourseID,
            section_id:selectedSectionID,
            archiveMode:this.state.archiveMode,
            semesterID:this.state.selectedSemesterID
            };
            
            
            let apiURL  =  "/getAllQuiz"
            
            try{
                
                let getAllQuizesResponse = await ApiRequestService({
                method: 'post',
                url:apiURL,
                data: payload
                });
                console.log("getAllQuizesResponse",getAllQuizesResponse);
                
                if(getAllQuizesResponse.data 
                    &&
                    getAllQuizesResponse.data.data 
                    && getAllQuizesResponse.data.data.quizes_list){
                        return getAllQuizesResponse.data.data;                        
                }
                
            }catch(err){
               
                return err;
            }finally{
                
            }
    }

    rowGetter = (i) => {
        if(this.state.rows.length > 0 ){
           return this.state.rows[i];
        }
        return null;
    };

    handleSetRows = (sortColumn, sortDirection) => {
        let initialRows = this.state.rows
        const comparer = (a, b) => {
            if (sortDirection === "ASC") {
            return a[sortColumn] > b[sortColumn] ? 1 : -1;
            } else if (sortDirection === "DESC") {
            return a[sortColumn] < b[sortColumn] ? 1 : -1;
            }
        };
        let temp = sortDirection === "NONE" ? initialRows : [...initialRows].sort(comparer);

        this.setState({
            rows:temp
        })
    }

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        let gradebookRow = {}
        let gradebookArrayLocal =    this.gradebookArray;
        let rows = this.state.rows; //Updating UI
        gradebookRow = gradebookArrayLocal[fromRow];
        console.log("updated",updated);
        
        if(gradebookRow !== null){
            if(updated !== undefined && updated !== null){
               
                for(let key in updated) {
                    
                    
                    let quizID = parseInt(key.replace("TotalScore_",""),10);
                    let value = parseInt(updated[key],10);
                    let quizIndex = gradebookRow.Grades.findIndex((element) => element.QuizID === parseInt(quizID,10))
                    
                    if (rows[fromRow][key] && rows[fromRow][key].score === value)
                        break;

                        if(gradebookRow.Grades[quizIndex]){
                            gradebookRow.Grades[quizIndex].EditedScore =   value;
                            gradebookRow.Grades[quizIndex].EditedBy =    window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`);
                            gradebookRow.Grades[quizIndex].ScoreChanged    = true;
                            gradebookArrayLocal[fromRow] = gradebookRow;
                            this.updateScore(gradebookRow.Grades[quizIndex]);
                            this.gradebookArray = gradebookArrayLocal;
                            rows[fromRow][key].score = value;
                            rows[fromRow][key].editedBy   =   window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`);
                            rows[fromRow][key].highlight = true;
                            this.setState({rows});
                        }
                     
                }
                
            }
        }

    };

    
    updateScore = async (quiz) =>
    {
      
        let payload = {
            quizID:quiz.QuizID,
            userID:quiz.UserID,
            courseID:quiz.CourseID,
            sectionID:quiz.SectionID,
            totalScore:quiz.EditedScore
        }

        try{
            let res =  await ApiRequestService({
                                        method: 'post',
                                        url:'updateGrade',
                                        data: payload
                                    });
            if(res.data !== undefined
            && res.data !== null 
            && res.data.status !== undefined
            && res.data.status !== null)
            {
                if(res.data.status !== 0)
                {
                    NotificationManager.error(res.data.message,"Error",5000);
                }else  {
                    NotificationManager.success("Score Updated","Success",5000);
                }
                
            }
        }catch(err){
            NotificationManager.error("There was an Error when loading Gradebook, please contact support team with the Error =>"+err,"Error",5000);
        }
    }

    //Build Quiz Filter Checkbox Data
    fillQuizFilterCheckBox  =   (rows) => {
        
        
        if(rows  && rows.length > 0){
           const quizCheckBox = rows.map(function(quiz) {
               
               
                //Get the Quiz list for the first user, and use it to build the quiz Column
                return {'label':quiz.quiz_name,'id':quiz.quiz_id,'value':true};
            });

            this.setState({quizCheckBox});
        }
    }

    onQuizFilterToggle(vals){    
        
        this.setState({quizCheckBox:[...vals]},() => {
            this.buildGradeBookColumns(this.allQuizes,!this.state.archiveMode);
        });
    }

    //Create Gradebook UI Data
    buildUIData =   (gradebookArray) =>{
        let sectionIDsMap = getSectionIDsMap(this.state.selectedSectionIDs);
        if(gradebookArray !== undefined && gradebookArray!== null && gradebookArray.length > 0 && sectionIDsMap !== undefined && sectionIDsMap!==null){
           console.debug("gradebookArray ",gradebookArray)
            let rows = gradebookArray.map((gradeBook)=>{
                
                    let grades = gradeBook.Grades
                    if(grades !== null && grades.length > 0){
                        let row = {};
                        row["FirstName"]  = grades[0].FirstName  
                        row["LastName"]  = grades[0].LastName
                        row["OSUID"]  = grades[0].OSUID
                        row["UserID"]  = grades[0].UserID
                        row["RoleID"] = grades[0].RoleID;
                        row["SectionName"]  = sectionIDsMap[grades[0].SectionID].label !== undefined && sectionIDsMap[grades[0].SectionID].label !== null ? sectionIDsMap[grades[0].SectionID].label : "" ;
                        let totalScore  =   0;
                        let gradedQuizCount = 0
                        grades.forEach((quiz)  =>{
                            let quizScore = 0;
                            row["NoOfCatsMastered_"+quiz.QuizID] = quiz.NoOfCatsMastered
                            row["TotalScore_"+quiz.QuizID] = {};
                            if(quiz.ScoreChanged !== undefined && quiz.ScoreChanged !== null && quiz.ScoreChanged ){
                                quizScore   =   quiz.EditedScore;
                                row["TotalScore_"+quiz.QuizID].editedBy   =   quiz.EditedBy;

                            }
                            else if(quiz.TotalScore !== undefined && quiz.TotalScore !== null && quiz.TotalScore > 0 )
                            {
                                /* if(quiz.FullScoreIfAttempted !== 0){
                                    quizScore = (quiz.OverAllQuestionCount === quiz.QuesAtt? 
                                        100
                                        : Math.round(100 * (quiz.QuesAtt/this.questionCount[quiz.QuizID]))
                                        )
                                }else if(quiz.QuizType === 0 ){
                                    quizScore = quiz.TotalScore
                                }else{ 
                                    quizScore   = Math.round(100 * (quiz.TotalScore/this.questionCount[quiz.QuizID]));
                                } */
                                quizScore = quiz.TotalScore
                            }
                            else if(quiz.QuizType === 0 )//else if(quiz.QuizType === 0 && quiz.SkillMast !== 0)
                            {
                                //quizScore = (quiz.SkillMast/quiz.SkillTot) * 100;
                                quizScore = quiz.TotalScore
                            }  
                            let IsNongraded = false;
                            if(quiz.IsNongraded === 1) {
                                IsNongraded = true
                            }
                            if(!isNaN(quizScore) && quizScore !== Infinity && !IsNongraded){
                                gradedQuizCount = gradedQuizCount + 1
                                totalScore  =  totalScore +  parseInt(quizScore,10);
                            }
                            
                                if(!quiz.ScoreChanged && quiz.FullScoreIfAttempted) { 
                                    row["TotalScore_"+quiz.QuizID].score = Math.round((quiz.QuesAtt/((quiz.OverAllQuestionCount)))*100); 
                                } else { 
                                    row["TotalScore_"+quiz.QuizID].score = quizScore;
                                }                                   

                            row["TotalScore_"+quiz.QuizID].highlight = quiz.ScoreChanged;
                        });
                        if (gradedQuizCount === 0) {
                            gradedQuizCount = 1
                        }
                        let meanScore = totalScore/gradedQuizCount
                        row["MeanScore"] = Math.round((meanScore + Number.EPSILON) * 100) / 100
                        row["TotalScore"]   =   totalScore;
                        return row;
                    }
                    return null;
                
            })
            // update allRows
            this.setState({allRows:rows});

            // Filter out users instructor and admin(role 1 and 2)
            const filteredRows = rows.filter(row => {
                if (!this.state.includeInstructorGrade) {
                    return row && row.RoleID !== 1 && row.RoleID !== 2;
                }
                return true;
            });
            this.setState({rows: filteredRows});
           
            
        }
    }
   

    //Build GradeBook Columns
    buildGradeBookColumns = (rows,allowScoreEdit) => {
        
        
        let commonColumns = [{
            key: 'UserID',
            name: 'User ID',
            editable: false,
            width: 150,
            resizable: true,
            locked: true
        },{
            key: 'FirstName',
            name: 'First Name',
            editable: false,
            width: 150,
            resizable: true
        },{
            key: 'LastName',
            name: 'Last Name',
            editable: false,
            width: 150,
            resizable: true
        },{
            key: 'OSUID',
            name: 'OSUID',
            editable: false,
            width: 150,
            resizable: true,
            
            
        },
        {
            key: 'SectionName',
            name: 'Section',
            editable: false,
            width: 150,
            resizable: true,
            
            
        }]
        let tempTotScore = {};
        let quizColumns = [];
        let quizScoreHeaderRenderer =   this.quizScoreHeaderRenderer;
        let gradeBookObj    = this;
        //Used for Building Quiz Filter Checkbox

        if(rows && rows.length > 0){
            
            //Get the Quiz list for the first user, and use it to build the quiz Column
            let quizList   = [...rows];

            if(quizList !== undefined && quizList !== null && quizList.length > 0)
            {  
                
                quizColumns =   quizList.reduce(function(quizColumns,quiz,index) {
                    
                //console.debug(index, gradeBookObj.state.quizCheckBox[index].id,gradeBookObj.state.quizCheckBox,quizList)
                    
                let tempIndex = index
                if(gradeBookObj.state.quizCheckBox.length === quizList.length+2){
                    tempIndex++
                }
                //console.debug("in tempIndex index condition",tempIndex,index)
                const key = 'TotalScore_'+quiz.quiz_id;
                if( gradeBookObj.state.quizCheckBox[tempIndex]!== undefined && 
                    gradeBookObj.state.quizCheckBox[tempIndex]!== null && 
                    gradeBookObj.state.quizCheckBox[tempIndex].value !== undefined &&
                    gradeBookObj.state.quizCheckBox[tempIndex].value !== null &&
                    gradeBookObj.state.quizCheckBox[tempIndex].value){ 
                        //console.debug("Inside condition ",tempIndex,gradeBookObj.state.quizCheckBox[tempIndex].id,gradeBookObj.state.quizCheckBox[tempIndex].value )
                        quizColumns.push({
                            key:key,
                            quizName:quiz.quiz_name,
                            editable: allowScoreEdit,
                            width: 150,
                            resizable: true,
                            formatter:TotalScoreFormatter,
                            headerRenderer:quizScoreHeaderRenderer(quiz,tempIndex),
                            editor:allowScoreEdit?TotalScoreEditor:null
                        });
                        //let temp = 'TotalScore_'+index
                        tempTotScore[key]=true;
                    }
                console.debug("quizColumns ",quizColumns,tempTotScore)
                return quizColumns;
                }, []);
                    
            }else
            {
                NotificationManager.error("There are no valid/completed assignment","Error",5000);
            }

            
            
        
        }
        

       
        let columnsForQuiz = commonColumns.concat(quizColumns);

        //Adding Mean Score Column
        columnsForQuiz  =   columnsForQuiz.concat([{
            key: 'MeanScore',
            name: 'Mean Score',
            editable: false,
            width: 100,
            resizable: true,
            
        }])
        //Adding Total Score Column
        columnsForQuiz  =   columnsForQuiz.concat([{
            key: 'TotalScore',
            name: 'Total Score',
            editable: false,
            width: 100,
            resizable: true,
            
        }])

        // For Practice details
        if(rows && rows.length > 0){
            
            //Get the Quiz list for the first user, and use it to build the quiz Column
            let quizList   = [...rows];

            if(quizList !== undefined && quizList !== null && quizList.length > 0)
            {  
                
                quizColumns =   quizList.reduce(function(quizColumns,quiz,index) {
                    
                let tempIndex = index
                if(gradeBookObj.state.quizCheckBox.length === quizList.length+2){
                    tempIndex++
                }

                const key = 'NoOfCatsMastered_'+quiz.quiz_id;
                if( gradeBookObj.state.quizCheckBox[tempIndex]!== undefined && 
                    gradeBookObj.state.quizCheckBox[tempIndex]!== null && 
                    gradeBookObj.state.quizCheckBox[tempIndex].value !== undefined &&
                    gradeBookObj.state.quizCheckBox[tempIndex].value !== null &&
                    gradeBookObj.state.quizCheckBox[tempIndex].value){ 
                        //console.debug("Inside condition ",tempIndex,gradeBookObj.state.quizCheckBox[tempIndex].id,gradeBookObj.state.quizCheckBox[tempIndex].value )
                        quizColumns.push({
                            key:key,
                            quizName: quiz.quiz_name,
                            editable: false,
                            width: 150,
                            resizable: true,
                            headerRenderer: <div style={{textAlign:"center"}}>
                                <div>{quiz.quiz_name}</div>
                                <div>{`(Practiced categories)`}</div>
                            </div>

                        });
                        tempTotScore[key]=true;
                    }
                return quizColumns;
                }, []);
                    
            }else
            {
                NotificationManager.error("There are no valid/completed assignment","Error",5000);
            }
        }

        columnsForQuiz = columnsForQuiz.concat(quizColumns);

        console.debug("columnsForQuiz m",columnsForQuiz)
        console.debug("tempTotScore m",tempTotScore)
        if(this.state.columnsForQuiz.length !== columnsForQuiz.length )
            this.setState({
                columnsForQuiz:columnsForQuiz,
                availabelTotScore:tempTotScore
            });
        
    }

    //Column Renderer
    quizScoreHeaderRenderer  =   (quiz,index) =>{
        let onClick = async (quiz) => {

            //Setting quiz Data to statsObject
            //this.quisStats =   quiz;
            quiz.courseID  = this.state.selectedCourseID;

            quiz.sectionIDs = this.state.selectedSectionIDs;
            this.setState({fetchingQuizStats:true});
            this.setState({showDialog:true});
            let stats =  await getQuizStats(quiz);
            try{
                
                this.quisStats = stats;
                this.quisStats.quizName =  quiz.quiz_name;  
            }catch(err){
                console.error(err);
                NotificationManager.error(err,"Error",5000);
                this.setState({showDialog:false});
            }finally{
                this.setState({fetchingQuizStats:false});
            }
            
        }
        return <QuizScoreColumn quiz={quiz} onClick={onClick} index={index}></QuizScoreColumn>; 
   } 

  

   //Quiz Stats Dialog Functions

   //Hide Dialog
   onDialogHide =  ()  => {
       this.setState({showDialog:false})
   } 

   //Download CSV Logic
   downloadCSV = () => {
    this.setState({buildingOverViewCSV:true});
    
    try{
        //Build Header
        //I am using the columnsForQuiz, since it would already contain the filtered column data
        let cvsData = [];
        //console.debug("csv ",this.state.columnsForQuiz)
        let cvsHeader = ['User ID','First Name','Last Name','OSUID','Section ID'];
        if (this.state.columnsForQuiz.length > 0){
            const columnsForQuiz = this.state.columnsForQuiz;
            console.debug("columnsForQuiz", columnsForQuiz)
            let column = {};
            for(var i = 5;i<columnsForQuiz.length;i++){
                column = columnsForQuiz[i];
                if (column.key.includes("TotalScore_")) {
                    cvsHeader.push(column.quizName);
                    cvsHeader.push('Score Edited');
                    cvsHeader.push('Edited By');
                } else if (column.key.includes("NoOfCatsMastered_")) {
                    cvsHeader.push(column.quizName + ' (Practiced Categories)');
                } else {
                    cvsHeader.push(column.name);
                }
            }
            // cvsHeader.push('Total');
            cvsData.push(cvsHeader);
            //console.debug('this.state.rows',this.state.rows)
            
            if(this.state.rows.length > 0 ){
                this.state.rows.forEach(row =>{
                    
                    cvsData.push(this.rowGetterCSV(row,cvsHeader));
                    
                })
            }
         
            console.debug("cvsData", cvsData)

        
        this.setState({
            overAllCSVData:cvsData
        },()=>{
            this.refs.btnOverViewCSV.link.click();
        })
       
        }
    }catch(err){
          console.error(err);
          NotificationManager.error("There was an Error , while generating CSV - "+err,"Error ",5000);
    }finally{
        this.setState({buildingOverViewCSV:false});
    }

    
   
   }
   
   rowGetterCSV = (gradesRef) => {
           
               const {columnsForQuiz} = this.state;
               const row = [];
               columnsForQuiz.forEach(columnObj=>{
                   const {key} = columnObj;
                   let grades = JSON.parse(JSON.stringify(gradesRef));
                  
                   if(key.includes('TotalScore_')){
                       console.log(grades);
                       console.log(key);
                       const grade = grades[key];
                        if(grade){
                            row.push(grade.score);
                            if(grade.highlight !== undefined && grade.highlight){
                                row.push("yes");
                                row.push(grade.editedBy);
                            }else{
                                row.push("no");
                                row.push("");
                            }
                        }else{
                            row.push("");
                            row.push("");
                            row.push("");
                        }
                        
                   }else{
                    row.push(grades[key]);
                   }
               });
               return row;
    };

    //Student Stats
    closeDrawer = () => {
        this.setState({ showStudentStatsDrawer: false });
      };

    handleStudentDrawerVisibility = (visible) => {
    this.setState({ showStudentStatsDrawer:visible });
    };
   //Render Method
   
    render(){
      
        let {gradeBookHeight} = this.state;
        if(gradeBookHeight === -1 ){
            gradeBookHeight = this.calculateGradebookHeight();
        } 
        return  <SecureShow targetRole={1}>
                    <Grid gutter={1} className="gradeBookPageContainer">
                        <Cell style={{width:"100%"}}>   <h1>Gradebook</h1></Cell>
                        {this.state.archiveMode && !this.state.loadingArchivedList?
                            <Cell size={2} phoneSize={4} tabletSize={6} id="semesterDropboxCell">
                                <label htmlFor="semesterSelectBox">
                                    {this.appProperties.schoolMode?"Standard":"Semester"} </label>
                                <SelectField
                                    id="semesterSelectBox"
                                    className="gradebook-dropdown"
                                    placeholder={this.appProperties.schoolMode?"Select an Academic Year ":"Select Semester"}
                                    menuItems={this.state.archivedSemester}
                                    onChange={this.onSemesterChange}
                                    defaultValue={this.state.selectedSemesterID}
                                />
                            </Cell>
                        :
                        null}
                        {
                            this.state.loadingCourse?null:
                            
                            <Cell size={3} phoneSize={4} tabletSize={6} id="courseDropboxCell">
                             
                        <label htmlFor="courseSelectBox">
                            {this.appProperties.schoolMode?'Standard':'Course'} </label>
                            <CourseDropDown
                            selectBoxID="courseSelectBox"
                            placeholder= {this.appProperties.schoolMode?'Select Standard':'Select Course'}
                            fullWidth
                            courses={this.state.courses}
                            archiveMode={this.state.archiveMode}
                            itemLabel={this.state.archiveMode?"label":"title"}
                            onChange={this.onCourseChange}
                            className=" gradebook-dropdown"/>
                            </Cell>
                        }
                        
                        {this.state.selectedCourseID === 0?null:
                        <Cell size={6} phoneSize={4} tabletSize={6} id='sectionSelectBoxCell' className='gradebook-section-dropdown-cell'>
                            <label htmlFor="sectionSelectBox">Section </label>
                            <SectionDropDown
                            selectedCourseID={this.state.selectedCourseID}
                            selectedSemesterID={this.state.selectedSemesterID}
                            selectBoxID="sectionSelectBox"
                            placeholder="Select   Section"
                            fullWidth
                            archiveMode
                            sectionMap={this.state.sectionMap}
                            onChange={this.onSectionChange}
                            className=" gradebook-dropdown"
                            selectAll={true}/>
                        </Cell>
                        }
                        {this.state.allRows.length > 0
                            &&
                            <Cell size={3} phoneSize={4} tabletSize={6} className='gradebook-checkbox'>
                                <Checkbox
                                id="include-instructor-grade"
                                label="Include Instructor"
                                checked={this.state.includeInstructorGrade}
                                onChange={this.handleToggleInstructorGrade}
                            />
                            </Cell>
                        }
                        {
                        this.state.selectedSectionIDs.length === 0?null:
                        <Cell  size={2} phoneSize={4} tabletSize={6} style={{textAlign:"right"}}>                    
                        {
                             this.state.buildingOverViewCSV?
                             <div className="overview-csv-loader"><BeatLoader    loading={this.state.buildingOverViewCSV}  color={'#bb0000'} size={10} /></div>
                             : this.state.rows !== undefined &&  this.state.rows !== null && this.state.rows.length > 0 
                             ?
                             <Button style={{marginTop:"15px"}} flat primary iconChildren="cloud_download" onClick={this.downloadCSV}>Download CSV</Button>:
                             null
                        }
                                
                        </Cell>
                        }
                         <Cell size={12} phoneSize={4} tabletSize={8} >
                        {
                            this.state.columnsForQuiz.length > 0 && this.state.rows.length > 0?
                        
                        
                        <ReactDataGrid
                           enableCellSelect={true}
                           columns={(this.state.columnsForQuiz).map(c => ({ ...c, sortable: true }))}
                           rowGetter={this.rowGetter}
                           rowsCount={this.state.rows.length}
                           minHeight={gradeBookHeight}
                           headerRowHeight={75}
                           rowHeight={30}
                           toolbar={<GradeBookToolbar onQuizFilterToggle={this.onQuizFilterToggle} quizCheckBox={this.state.quizCheckBox} />}
                           onGridRowsUpdated={this.handleGridRowsUpdated}
                           onGridSort={(sortColumn, sortDirection) =>
                            this.handleSetRows(sortColumn, sortDirection)
                           }
                            sortColumn= {"LastName"}
                            sortDirection= {'ASC'}
                           />
                            :
                         <LoadingSpinner loading={this.state.fetchingGradebook} />
                        }
                          </Cell>
                        
                    </Grid>
                    <NotificationContainer></NotificationContainer>
                    <DialogContainer
                     width={400}
                     id="gradeBookDialog"
                     visible={this.state.showDialog}
                     onHide={this.onDialogHide}
                     aria-describedby="gradebook-popup"
                     focusOnMount={false}
                     >
                     {
                        this.state.fetchingQuizStats?
                        <LoadingSpinner loading={this.state.fetchingQuizStats} />
                        :
                        <QuizStatsReport stats={this.quisStats} id='gradebook-popup'></QuizStatsReport>
                     }
                    </DialogContainer>
                    <CSVLink ref="btnOverViewCSV"  filename={"Export.csv"} data={this.state.overAllCSVData} style={{display:'none'}}/>
                    
                </SecureShow>
    }
}
